import { render, staticRenderFns } from "./FreeScreen.vue?vue&type=template&id=403c0001&scoped=true"
import script from "./FreeScreen.vue?vue&type=script&lang=js"
export * from "./FreeScreen.vue?vue&type=script&lang=js"
import style0 from "./FreeScreen.vue?vue&type=style&index=0&id=403c0001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "403c0001",
  null
  
)

export default component.exports